function Accordion(accordionId, resetOnEveryClick = false) {
  this.accordion = document.getElementById(accordionId)
  this.accordionBtns = this.accordion.querySelectorAll('button')
  this.lastClickedId = null
  this.resetAllActive = resetOnEveryClick

  this.init = function() {
    this.accordionBtns.forEach((btn, index) => {
      const parentContainer = btn.closest('.item')
      const msgContainer = parentContainer?.querySelector('.item-answer')

      if (!parentContainer || !msgContainer) return

      const childId = `msg-${index}`
      const btnId = `btn-${index}`

      // Setup message container attributes
      msgContainer.id = childId
      msgContainer.setAttribute('aria-labelledby', btnId)
      msgContainer.setAttribute('aria-controlledby', btnId)

      // Setup button attributes
      btn.id = btnId
      btn.setAttribute('role', 'button')
      btn.setAttribute('aria-label', `${index + 1} of ${this.accordionBtns.length}`)
      btn.setAttribute('aria-expanded', 'false')
      btn.setAttribute('aria-controls', childId)
      btn.addEventListener('click', this.handleClick.bind(this))
    })
  }

  this.toggleAccordionState = function(button, isActive) {
    const contentBox = button.nextElementSibling
    const parentItem = button.closest('.item')

    if (isActive) {
      button.classList.add('active')
      button.setAttribute('aria-expanded', 'true')
      contentBox.setAttribute('aria-expanded', 'true')
      contentBox.style.height = contentBox.scrollHeight + 'px'
      parentItem?.classList.add('active')
    } else {
      button.classList.remove('active')
      button.setAttribute('aria-expanded', 'false')
      contentBox.setAttribute('aria-expanded', 'false')
      contentBox.style.height = '0'
      parentItem?.classList.remove('active')
    }
  }

  this.resetAllAccordions = function() {
    this.accordionBtns.forEach(btn => {
      if (btn.classList.contains('active')) {
        this.toggleAccordionState(btn, false)
      }
    })
  }

  this.handleClick = function(e) {
    const currentButton = e.target
    const isCurrentlyActive = currentButton.classList.contains('active')

    // Handle same button clicked twice
    if (currentButton.id === this.lastClickedId) {
      this.lastClickedId = currentButton.id
      this.toggleAccordionState(currentButton, !isCurrentlyActive)
      return
    }

    // Reset all other accordions if resetAllActive is enabled
    if (this.resetAllActive) {
      this.resetAllAccordions()
    }

    // Toggle the clicked accordion
    if (this.lastClickedId !== currentButton.id) {
      this.lastClickedId = currentButton.id
      this.toggleAccordionState(currentButton, !isCurrentlyActive)
    }
  }

  // Initialize the accordion
  this.init()
}